import { useContext, useRef } from "react";
import { uploadDomeniuDocument } from "../backend/FileUploadService";
import folder from "../imgs/folder.png";
import { useNavigate } from "react-router-dom";
import { RefreshContext } from "../context/RefreshContext";
import { months } from "../utils/Values";

const DomainHeader = ({
  domeniuName,
  domeniuClassName,
  setShowModalCallback,
}) => {
  const hiddenDocumentInput = useRef(null);
  const navigate = useNavigate();
  const {
    reviziiFaza1,
    setReviziiFaza1,
    iscirFaza1,
    setIscirFaza1,
    currentMonth,
    setCurrentMonth,
  } = useContext(RefreshContext);
  const chooseDocumentToUpload = (e) => {
    e.preventDefault();
    e.stopPropagation();
    hiddenDocumentInput.current?.click();
  };

  const handleGoToViewer = (e) => {
    if (e.button !== 0) return; // only left click
    navigate("/documenteDomeniuFoldereViewer", {
      state: { locationType: domeniuName },
    });
  };

  const handleUploadDocument = async (event) => {
    try {
      const fileToUpload = event.target.files[0];
      if (!fileToUpload) return;

      const formData = new FormData();
      formData.append("file", fileToUpload);
      await uploadDomeniuDocument(formData, domeniuName.toLowerCase());

      event.target.value = "";
    } catch (err) {
      // setError("Eroare la atasarea documentelor.");
    }
  };

  return (
    <div className="headerWrapper">
      <div
        className={domeniuClassName}
        onClick={() => setShowModalCallback(true)}
      >
        <h2>{domeniuName}</h2>
      </div>

      <div
        style={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
        }}
        onContextMenu={(e) => e.preventDefault()}
      >
        {domeniuName.toLowerCase() === "revizii" && (
          <div className="psi_header_months">
            <div
              onClick={() => {
                setReviziiFaza1(!reviziiFaza1);
              }}
              className={
                reviziiFaza1
                  ? "iscir_header_button_selected"
                  : "iscir_header_button"
              }
            >
              REGEN
            </div>
          </div>
        )}
        {domeniuName.toLowerCase() === "iscir" && (
          <div className="psi_header_months">
            <div
              onClick={() => {
                setIscirFaza1(!iscirFaza1);
              }}
              className={
                iscirFaza1
                  ? "iscir_header_button_selected"
                  : "iscir_header_button"
              }
            >
              REGEN
            </div>
          </div>
        )}
        {domeniuName.toLowerCase() === "psi" && (
          <div className="psi_header_months">
            {months.map((month, index) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    if (currentMonth === month) setCurrentMonth(null);
                    else setCurrentMonth(month);
                  }}
                  className={
                    currentMonth === month
                      ? "psi_header_month_selected"
                      : "psi_header_month"
                  }
                >
                  {month.label}
                </div>
              );
            })}
          </div>
        )}
        <div
          style={{ display: "flex", justifyContent: "flex-end", flexGrow: 1 }}
        >
          <div
            className="d-inline-block mr-2 locatie_istoric_and_gallery_button"
            onMouseDown={handleGoToViewer}
            onContextMenu={chooseDocumentToUpload}
          >
            <input
              type="file"
              style={{ display: "none" }}
              onChange={handleUploadDocument}
              ref={hiddenDocumentInput}
            />
            <img src={folder} alt="photos" style={{ maxHeight: "100%" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DomainHeader;
